import azulIcon from "../assets/img/providers/azul-icon.jpeg";
import cloverIcon from "../assets/img/providers/clover-icon.svg";
import divixIcon from "../assets/img/providers/divix-icon.svg";

export type ProviderTheme = {
  text: string;
  background: string;
  border: string;
}

export type ProviderConfig = {
  id: string;
  name: string;
  displayName: string;
  icon: string;
  theme: ProviderTheme;
}
export const PAYMENT_PROVIDERS: Record<string, ProviderConfig> = {
  clover: {
    id: "clover",
    name: "Clover",
    displayName: "Clover",
    icon: cloverIcon,
    theme: {
      text: "#228800",
      background: "#FFFFFF",
      border: "#228800",
    },
  },
  divix: {
    id: "divix",
    name: "Divix",
    displayName: "Divix",
    icon: divixIcon,
    theme: {
      text: "#EF0BB8",
      background: "#FFFFFF",
      border: "#EF0BB8",
    },
  },
  azul: {
    id: "azul",
    name: "Azul",
    displayName: "Azul",
    icon: azulIcon,
    theme: {
      text: "#0066CC",
      background: "#FFFFFF",
      border: "#0066CC",
    },
  },
};
